import { post } from "../utils/backend";
import { RemoteJob, SaveRemoteJobParam } from "../models/RemoteJob";
import { JobApplicant, ApplicationManageStatus } from "../models/JobApplicant";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import { mockJobs } from "./mock/JobMock";
import "./mock/JobMock";

const getJobs = async (): Promise<RemoteJob[]> => {
    if (mock) {
        return getMockData("getJobs");
    }
    const resultOrErrorCode = await post<null, RemoteJob[]>("/management/job/getJobs", null);
    if (typeof resultOrErrorCode === "string") {
        return [];
    }
    return resultOrErrorCode;
};

const createJob = async (params: SaveRemoteJobParam): Promise<RemoteJob | null> => {
    if (mock) {
        const newJob: RemoteJob = {
            id: `job_${Date.now()}`,
            title: params.title,
            description: params.description,
            status: "active",
            type: params.type,
            salaryRangeStart: params.salaryRangeStart,
            salaryRangeEnd: params.salaryRangeEnd,
            isHidden: false,
            isClosed: false,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
        };
        mockJobs.unshift(newJob);
        return newJob;
    }
    const resultOrErrorCode = await post<SaveRemoteJobParam, RemoteJob>("/management/job/create", params);
    if (typeof resultOrErrorCode === "string") {
        return null;
    }
    return resultOrErrorCode;
};

const updateJob = async (params: SaveRemoteJobParam): Promise<RemoteJob | null> => {
    if (mock) {
        const job = mockJobs.find(item => item.id === params.id);
        if (job) {
            Object.assign(job, params, { updatedAt: new Date().toISOString() });
            return job;
        }
        return null;
    }
    const resultOrErrorCode = await post<SaveRemoteJobParam, RemoteJob>("/management/job/update", params);
    if (typeof resultOrErrorCode === "string") {
        return null;
    }
    return resultOrErrorCode;
};

const closeJob = async (jobId: string): Promise<boolean> => {
    if (mock) {
        const job = mockJobs.find(item => item.id === jobId);
        if (job) {
            job.status = "closed";
            job.isClosed = true;
            job.updatedAt = new Date().toISOString();
            return true;
        }
        return false;
    }
    const resultOrErrorCode = await post<{ jobId: string }, boolean>("/management/job/close", { jobId });
    if (typeof resultOrErrorCode === "string") {
        return false;
    }
    return resultOrErrorCode;
};

const getApplicants = async (jobId: string): Promise<JobApplicant[]> => {
    if (mock) {
        return getMockData("getJobApplicants").filter((item: JobApplicant) => item.jobId === jobId);
    }
    const resultOrErrorCode = await post<{ jobId: string }, JobApplicant[]>(
        "/management/job/getApplicants",
        { jobId },
    );
    if (typeof resultOrErrorCode === "string") {
        return [];
    }
    return resultOrErrorCode;
};

const updateApplicationStatus = async (
    applicationId: string,
    status: ApplicationManageStatus,
): Promise<boolean> => {
    if (mock) {
        const applicants = getMockData("getJobApplicants") as JobApplicant[];
        const target = applicants.find(item => item.applicationId === applicationId);
        if (target) {
            target.status = status;
        }
        return !!target;
    }
    const resultOrErrorCode = await post<
        { applicationId: string; status: ApplicationManageStatus },
        boolean
    >("/management/job/updateApplicationStatus", { applicationId, status });
    if (typeof resultOrErrorCode === "string") {
        return false;
    }
    return resultOrErrorCode;
};

export const JobApi = {
    getJobs,
    createJob,
    updateJob,
    closeJob,
    getApplicants,
    updateApplicationStatus,
};
